import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const categories = [
  { id: 'all', name: 'All Products', icon: 'ri-store-2-line' },
  { id: 'juices', name: 'Wellness Juices', icon: 'ri-goblet-line' },
  { id: 'oils', name: 'Essential Oils', icon: 'ri-drop-line' },
  { id: 'candles', name: 'Aromatherapy Candles', icon: 'ri-fire-line' },
];

const products = [
  // Wellness Juices
  {
    id: 1,
    category: 'juices',
    name: 'Detox Green Juice',
    price: 12.99,
    description: 'Refreshing blend of kale, cucumber, celery, and lemon to cleanse and energize your body.',
    image: 'https://public.readdy.ai/ai/img_res/13cbd5d80025a9f40fb8f6023c4abc65.jpg',
    benefits: ['Detoxifies', 'Boosts Energy', 'Rich in Vitamins'],
  },
  {
    id: 2,
    category: 'juices',
    name: 'Immunity Boost Juice',
    price: 13.99,
    description: 'Powerful combination of orange, ginger, turmeric, and carrot to strengthen your immune system.',
    image: 'https://readdy.ai/api/search-image?query=bright%20orange%20immunity%20boosting%20juice%20in%20premium%20glass%20bottle%20with%20fresh%20oranges%20ginger%20turmeric%20and%20carrots%20arranged%20artistically%20on%20clean%20white%20surface%20natural%20lighting%20healthy%20wellness%20beverage%20product%20photography%20professional%20style%20emphasizing%20immune%20support%20and%20vitality&width=600&height=600&seq=juice002&orientation=squarish',
    benefits: ['Immune Support', 'Anti-inflammatory', 'Vitamin C Rich'],
  },
  {
    id: 3,
    category: 'juices',
    name: 'Heart Health Juice',
    price: 14.99,
    description: 'Beet, pomegranate, and berry blend designed to support cardiovascular wellness.',
    image: 'https://readdy.ai/api/search-image?query=deep%20red%20heart%20health%20juice%20in%20elegant%20glass%20bottle%20with%20fresh%20beets%20pomegranate%20and%20berries%20arranged%20beautifully%20on%20clean%20white%20surface%20natural%20lighting%20healthy%20wellness%20beverage%20product%20photography%20professional%20style%20emphasizing%20cardiovascular%20health%20and%20nutrition&width=600&height=600&seq=juice003&orientation=squarish',
    benefits: ['Heart Health', 'Circulation', 'Antioxidant Rich'],
  },
  {
    id: 4,
    category: 'juices',
    name: 'Calm & Restore Juice',
    price: 12.99,
    description: 'Soothing blend of lavender, blueberry, and chamomile to promote relaxation and mental clarity.',
    image: 'https://readdy.ai/api/search-image?query=calming%20purple%20wellness%20juice%20in%20elegant%20glass%20bottle%20with%20fresh%20lavender%20blueberries%20and%20chamomile%20flowers%20arranged%20peacefully%20on%20clean%20white%20surface%20soft%20natural%20lighting%20healthy%20beverage%20product%20photography%20professional%20style%20emphasizing%20relaxation%20and%20mental%20wellness&width=600&height=600&seq=juice004&orientation=squarish',
    benefits: ['Stress Relief', 'Mental Clarity', 'Promotes Sleep'],
  },

  // Essential Oils
  {
    id: 5,
    category: 'oils',
    name: 'Lavender Essential Oil',
    price: 18.99,
    description: 'Pure lavender oil for relaxation, stress relief, and better sleep quality.',
    image: 'https://readdy.ai/api/search-image?query=premium%20lavender%20essential%20oil%20in%20elegant%20amber%20glass%20bottle%20with%20fresh%20lavender%20flowers%20and%20dropper%20arranged%20beautifully%20on%20clean%20white%20surface%20natural%20lighting%20aromatherapy%20product%20photography%20professional%20style%20emphasizing%20purity%20relaxation%20and%20wellness&width=600&height=600&seq=oil001&orientation=squarish',
    benefits: ['Relaxation', 'Sleep Aid', 'Stress Relief'],
  },
  {
    id: 6,
    category: 'oils',
    name: 'Peppermint Essential Oil',
    price: 16.99,
    description: 'Invigorating peppermint oil to boost energy, focus, and respiratory health.',
    image: 'https://readdy.ai/api/search-image?query=refreshing%20peppermint%20essential%20oil%20in%20elegant%20amber%20glass%20bottle%20with%20fresh%20peppermint%20leaves%20and%20dropper%20arranged%20artistically%20on%20clean%20white%20surface%20natural%20lighting%20aromatherapy%20product%20photography%20professional%20style%20emphasizing%20energy%20focus%20and%20freshness&width=600&height=600&seq=oil002&orientation=squarish',
    benefits: ['Energy Boost', 'Mental Focus', 'Respiratory Support'],
  },
  {
    id: 7,
    category: 'oils',
    name: 'Eucalyptus Essential Oil',
    price: 17.99,
    description: 'Refreshing eucalyptus oil for respiratory wellness and mental clarity.',
    image: 'https://readdy.ai/api/search-image?query=pure%20eucalyptus%20essential%20oil%20in%20elegant%20amber%20glass%20bottle%20with%20fresh%20eucalyptus%20leaves%20and%20dropper%20arranged%20beautifully%20on%20clean%20white%20surface%20natural%20lighting%20aromatherapy%20product%20photography%20professional%20style%20emphasizing%20respiratory%20health%20and%20clarity&width=600&height=600&seq=oil003&orientation=squarish',
    benefits: ['Respiratory Health', 'Mental Clarity', 'Purifying'],
  },
  {
    id: 8,
    category: 'oils',
    name: 'Tea Tree Essential Oil',
    price: 15.99,
    description: 'Versatile tea tree oil known for its purifying and skin-supporting properties.',
    image: 'https://readdy.ai/api/search-image?query=natural%20tea%20tree%20essential%20oil%20in%20elegant%20amber%20glass%20bottle%20with%20fresh%20tea%20tree%20leaves%20and%20dropper%20arranged%20artistically%20on%20clean%20white%20surface%20natural%20lighting%20aromatherapy%20product%20photography%20professional%20style%20emphasizing%20purity%20and%20natural%20healing%20properties&width=600&height=600&seq=oil004&orientation=squarish',
    benefits: ['Purifying', 'Skin Support', 'Natural Cleanser'],
  },

  // Aromatherapy Candles
  {
    id: 9,
    category: 'candles',
    name: 'Tranquil Lavender Candle',
    price: 24.99,
    description: 'Hand-poured soy candle with pure lavender essential oil for peaceful relaxation.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20lavender%20aromatherapy%20candle%20in%20frosted%20glass%20jar%20with%20wooden%20lid%20and%20fresh%20lavender%20sprigs%20arranged%20beautifully%20on%20clean%20white%20surface%20soft%20natural%20lighting%20luxury%20home%20fragrance%20product%20photography%20professional%20style%20emphasizing%20tranquility%20and%20relaxation&width=600&height=600&seq=candle001&orientation=squarish',
    benefits: ['Relaxation', 'Stress Relief', 'Sleep Support'],
  },
  {
    id: 10,
    category: 'candles',
    name: 'Energize Citrus Candle',
    price: 24.99,
    description: 'Uplifting blend of orange, lemon, and grapefruit to invigorate your space.',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20citrus%20aromatherapy%20candle%20in%20frosted%20glass%20jar%20with%20wooden%20lid%20and%20fresh%20orange%20slices%20arranged%20artistically%20on%20clean%20white%20surface%20natural%20lighting%20luxury%20home%20fragrance%20product%20photography%20professional%20style%20emphasizing%20energy%20and%20freshness&width=600&height=600&seq=candle002&orientation=squarish',
    benefits: ['Energy Boost', 'Mood Uplift', 'Mental Clarity'],
  },
  {
    id: 11,
    category: 'candles',
    name: 'Zen Garden Candle',
    price: 26.99,
    description: 'Calming blend of jasmine, sandalwood, and bamboo for meditation and mindfulness.',
    image: 'https://readdy.ai/api/search-image?query=serene%20zen%20aromatherapy%20candle%20in%20frosted%20glass%20jar%20with%20wooden%20lid%20and%20bamboo%20leaves%20arranged%20peacefully%20on%20clean%20white%20surface%20soft%20natural%20lighting%20luxury%20home%20fragrance%20product%20photography%20professional%20style%20emphasizing%20meditation%20and%20mindfulness&width=600&height=600&seq=candle003&orientation=squarish',
    benefits: ['Meditation', 'Mindfulness', 'Inner Peace'],
  },
  {
    id: 12,
    category: 'candles',
    name: 'Healing Eucalyptus Candle',
    price: 25.99,
    description: 'Refreshing eucalyptus and mint blend to purify and restore your environment.',
    image: 'https://readdy.ai/api/search-image?query=refreshing%20eucalyptus%20aromatherapy%20candle%20in%20frosted%20glass%20jar%20with%20wooden%20lid%20and%20fresh%20eucalyptus%20leaves%20arranged%20beautifully%20on%20clean%20white%20surface%20natural%20lighting%20luxury%20home%20fragrance%20product%20photography%20professional%20style%20emphasizing%20healing%20and%20purification&width=600&height=600&seq=candle004&orientation=squarish',
    benefits: ['Purifying', 'Respiratory Support', 'Refreshing'],
  },
];

export default function ShopPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState<typeof products[0] | null>(null);

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-cream to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-charcoal mb-6">
              Wellness Shop
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Discover our curated collection of wellness juices, essential oils, and aromatherapy candles. Each product is crafted to support your journey toward alignment and restoration.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white sticky top-20 z-40 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-coral text-white shadow-lg'
                    : 'bg-gray-100 text-charcoal hover:bg-gray-200'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filteredProducts.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all group"
              >
                <div className="relative h-72 bg-gray-50 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-serif text-xl font-bold text-charcoal mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {product.description}
                  </p>
                  
                  {/* Benefits */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {product.benefits.map((benefit, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-coral/10 text-coral px-3 py-1 rounded-full"
                      >
                        {benefit}
                      </span>
                    ))}
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-coral">
                      ${product.price.toFixed(2)}
                    </div>
                    <button
                      onClick={() => setSelectedProduct(product)}
                      className="bg-coral text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-coral/90 transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
                    >
                      Order Now
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Order Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
          >
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <h2 className="font-serif text-3xl font-bold text-charcoal">
                  Order {selectedProduct.name}
                </h2>
                <button
                  onClick={() => setSelectedProduct(null)}
                  className="text-gray-400 hover:text-charcoal transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-3xl"></i>
                </button>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="relative h-64 bg-gray-50 rounded-2xl overflow-hidden">
                  <img
                    src={selectedProduct.image}
                    alt={selectedProduct.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-3xl font-bold text-coral mb-4">
                    ${selectedProduct.price.toFixed(2)}
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {selectedProduct.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {selectedProduct.benefits.map((benefit, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-coral/10 text-coral px-3 py-1.5 rounded-full"
                      >
                        {benefit}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <form
                id={`order-form-${selectedProduct.id}`}
                data-readdy-form
                action="https://readdy.ai/api/form/d61viqf4klnl5oj67ut0"
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  
                  fetch('https://readdy.ai/api/form/d61viqf4klnl5oj67ut0', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(formData as any).toString(),
                  })
                    .then(response => {
                      if (response.ok) {
                        alert('Order submitted successfully! We will contact you shortly with payment instructions.');
                        setSelectedProduct(null);
                        form.reset();
                      } else {
                        alert('There was an error submitting your order. Please try again.');
                      }
                    })
                    .catch(() => {
                      alert('There was an error submitting your order. Please try again.');
                    });
                }}
                className="space-y-4"
              >
                <input type="hidden" name="product" value={selectedProduct.name} />
                <input type="hidden" name="price" value={selectedProduct.price} />

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-charcoal mb-2">
                      Quantity
                    </label>
                    <input
                      type="number"
                      name="quantity"
                      min="1"
                      defaultValue="1"
                      required
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-coral text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-charcoal mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-coral text-sm"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-charcoal mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-coral text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-charcoal mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-coral text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-charcoal mb-2">
                    Shipping Address
                  </label>
                  <textarea
                    name="address"
                    rows={3}
                    required
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-coral text-sm resize-none"
                    placeholder="Street address, city, state, ZIP code"
                  ></textarea>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-charcoal mb-2">
                    Special Instructions (Optional)
                  </label>
                  <textarea
                    name="notes"
                    rows={2}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-coral text-sm resize-none"
                    placeholder="Any special requests or delivery instructions"
                  ></textarea>
                </div>

                <div className="bg-coral/10 rounded-xl p-4">
                  <div className="flex justify-between text-sm mb-2">
                    <span className="text-gray-600">Shipping Fee:</span>
                    <span className="font-semibold text-charcoal">$6.00</span>
                  </div>
                  <div className="flex justify-between text-lg font-bold">
                    <span className="text-charcoal">Total:</span>
                    <span className="text-coral" id={`total-${selectedProduct.id}`}>
                      ${(selectedProduct.price + 6).toFixed(2)}
                    </span>
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-coral text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-coral/90 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
                >
                  Submit Order
                </button>

                <p className="text-xs text-gray-500 text-center">
                  After submitting, we'll contact you with payment instructions and delivery details.
                </p>
              </form>
            </div>
          </motion.div>
        </div>
      )}

      {/* Info Section */}
      <section className="py-20 bg-gradient-to-br from-cream to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-coral/10 rounded-2xl mx-auto mb-4">
                <i className="ri-leaf-line text-3xl text-coral"></i>
              </div>
              <h3 className="font-serif text-xl font-bold text-charcoal mb-2">
                Natural Ingredients
              </h3>
              <p className="text-gray-600 text-sm">
                All products made with pure, organic ingredients for your wellness
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-coral/10 rounded-2xl mx-auto mb-4">
                <i className="ri-hand-heart-line text-3xl text-coral"></i>
              </div>
              <h3 className="font-serif text-xl font-bold text-charcoal mb-2">
                Handcrafted with Care
              </h3>
              <p className="text-gray-600 text-sm">
                Each product is carefully crafted in small batches for quality
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-coral/10 rounded-2xl mx-auto mb-4">
                <i className="ri-truck-line text-3xl text-coral"></i>
              </div>
              <h3 className="font-serif text-xl font-bold text-charcoal mb-2">
                Fast Delivery
              </h3>
              <p className="text-gray-600 text-sm">
                Quick and reliable shipping to bring wellness to your door
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />

      <script
        dangerouslySetInnerHTML={{
          __html: `
            document.querySelectorAll('[data-readdy-form]').forEach(form => {
              const productId = form.id.split('-').pop();
              const quantityInput = form.querySelector('input[name="quantity"]');
              const priceInput = form.querySelector('input[name="price"]');
              const totalElement = document.getElementById('total-' + productId);
              
              if (quantityInput && priceInput && totalElement) {
                quantityInput.addEventListener('input', function() {
                  const quantity = parseInt(this.value) || 1;
                  const price = parseFloat(priceInput.value);
                  const shipping = 6.00;
                  const total = (price * quantity) + shipping;
                  totalElement.textContent = '$' + total.toFixed(2);
                });
              }
            });
          `,
        }}
      />
    </div>
  );
}